import { useContext } from 'react';
import { Field } from 'formik';
import { TextField } from 'formik-material-ui';
import { Switch } from '../../../../common/formik';
import './../../../form.css';
import { Card, CardHeader, CardContent, Grid, Divider } from '@material-ui/core';
import { Select, FieldError } from '../../../../common';
import { AddressForm } from '../common/AddressForm';
import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';
import { SettingsContext } from '../../../../contexts';
import { SapTableNames, AppSettingNames } from '../../../../../helpers';
import { makeStyles } from '@material-ui/core/styles';
import { decimalNumberField } from '../../../../../helpers/Utils';
import { DbType } from '../../../../../helpers/Common';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    field: {
        width: '100%'
    },
    invalidField: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1)
    }
}));

export const CustomerInfoForm = (props) => {
    const classes = useStyles();

    const {
        state,
        getTableOptionsWithCode
    } = useContext(CustomerRequestContext)

    const {
        values,
        isSavingRequest
    } = useContext(TabsContext);

    const { appSettingsECC, appSettingsS4 } = useContext(SettingsContext);
    
    const italyCountrySetting = values.dbType === DbType.S4 ?
        appSettingsS4.find(x => x.appSettingKey === AppSettingNames.ItalyCountryId) :
        appSettingsECC.find(x => x.appSettingKey === AppSettingNames.ItalyCountryId);

    const italyCountryId = italyCountrySetting ? parseInt(italyCountrySetting.value) : 0;
    const isItalyCountrySelected = values.primaryAddress.countryId === italyCountryId;

    return (
        <Card>
            <CardHeader title="Customer information" />
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Field
                            name="customerName"
                            type="text"
                            style={{ width: "100%" }}
                            variant="outlined"
                            helperText="legal & registered company name"
                            label="Customer name *"
                            disabled={props.disabled}
                            component={TextField}
                        />
                        <FieldError name="customerName" errors={state.errors} />
                    </Grid>
                    <Grid item xs={12}>
                        <Field
                            multiline
                            type="text"
                            className={classes.field}
                            name="briefPresentation"
                            variant="outlined"
                            helperText="Type a brief presentetion of the new customer"
                            label="Brief presentation *"
                            disabled={props.disabled}
                            component={TextField}
                        />
                        <FieldError name="briefPresentation" errors={state.errors} />
                    </Grid>
                    <Divider className={classes.field} />
                    <Grid item xs={12}>
                        <AddressForm
                            address={values.primaryAddress}
                            formSuffixName="primaryAddress"
                            disabled={props.disabled}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Field
                            label="Has secondary address"
                            name="hasSecondaryAddress"
                            disabled={isSavingRequest || props.disabled}
                            component={Switch}
                        />
                        <FieldError name="hasSecondaryAddress" errors={state.errors} />
                    </Grid>
                    {values.hasSecondaryAddress &&
                        <Grid item xs={12}>
                            <AddressForm
                                address={values.secondaryAddress}
                                formSuffixName="secondaryAddress"
                                disabled={props.disabled}
                            />
                        </Grid>
                    }
                    <Divider className={classes.field} />
                    {!isItalyCountrySelected &&
                        <Grid item xs={12}>
                            <Field
                                label="Does the new customer have a VAT number?"
                                name="hasVatNumber"
                                disabled={isSavingRequest || props.disabled}
                                component={Switch}
                            />
                            <FieldError name="hasVatNumber" errors={state.errors} />
                        </Grid>
                    }
                    {values.hasVatNumber && (
                        <Grid item xs={6}>
                            <Field
                                className={classes.field}
                                variant="outlined"
                                type="text"
                                name="vatNumber"
                                label="VAT number *"
                                disabled={props.disabled}
                                component={TextField}
                            />
                            <FieldError name="vatNumber" errors={state.errors} />
                        </Grid>
                    )}
                    {values.hasVatNumber && (
                        <Grid item xs={6}>
                            <Field
                                className={classes.field}
                                variant="outlined"
                                type="text"
                                name="taxNumber"
                                label="TAX Number"
                                disabled={props.disabled}
                                component={TextField}
                            />
                            <FieldError name="taxNumber" errors={state.errors} />
                        </Grid>
                    )}
                    {values.hasVatNumber && isItalyCountrySelected && (
                        <Grid item xs={12}>
                            <Field
                                className={classes.field}
                                variant="outlined"
                                type="text"
                                name="sdiCode"
                                label="SDI Code *"
                                disabled={props.disabled}
                                component={TextField}
                            />
                            <FieldError name="sdiCode" errors={state.errors} />
                        </Grid>
                    )}
                    <Divider className={classes.field} />
                    <Grid item xl={10} md={12} xs={12}>
                        <Field
                            className={classes.field}
                            name="yearlySalesBudget"
                            variant="outlined"
                            label="Yearly sales budget *"
                            disabled={props.disabled}
                            component={decimalNumberField}
                        />
                        <FieldError name="yearlySalesBudget" errors={state.errors} />
                    </Grid>
                    <Grid item xl={2} md={12} xs={12}>
                        <Select
                            name="customerCurrencyId"
                            label="Currency *"
                            disabled={props.disabled}
                            options={getTableOptionsWithCode(SapTableNames.Currencies, values.dbType)}
                        />
                        <FieldError name="customerCurrencyId" errors={state.errors} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}


